export default __webpack_public_path__ + "static/media/Himanshi.f6408411.jpg";